import { env } from '@/configs/env'
import Logo from '@/assets/logo.svg'
import { MLabel, MLogo, Stack, styled, theme } from '@fruition/design-system'
import { Link } from 'react-router-dom'
import type { Props } from './SplittedView.types'

const BALANCE_HEIGHT = '60px'

const RightWrapper = styled(Stack)({
  background: `url("${Logo}") ${theme.palette.core.blue.level400}`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
})

export const SplittedView = ({ left, right }: Props) => {
  return (
    <Stack
      component="main"
      direction="row"
      flexGrow={1}
      justifyContent="space-between"
      minHeight="100dvh"
    >
      <Stack
        direction="column"
        alignItems="start"
        justifyContent="space-between"
        flexBasis={{ xs: '100%', md: '50%' }}
        margin={3}
      >
        <Stack
          direction="row"
          width="100%"
          height={BALANCE_HEIGHT}
          justifyContent={{ xs: 'center', sm: 'flex-start' }}
        >
          <Link to="/">
            <MLogo width="200px" />
          </Link>
        </Stack>
        <Stack
          flexGrow={1}
          justifyContent={{ xs: 'flex-start', xl: 'center' }}
          alignItems="center"
          width="100%"
          marginTop={{ xs: 3, sm: 8, md: 5.5, lg: 7, xl: 0 }}
        >
          {left}
        </Stack>
        <Stack height={BALANCE_HEIGHT} justifyContent="flex-end">
          <Stack direction="row" gap={0.5} flexWrap="wrap">
            <MLabel
              variant={theme.typography.body.medium.regular.normal}
              color={theme.palette.semantic.text.base.secondary}
            >
              Need Help? Please contact support at
            </MLabel>
            <MLabel
              variant={theme.typography.body.medium.regular.normal}
              color={theme.palette.core.blue.level500}
            >
              <a href={`mailto:${env.VITE_SUPPORT_EMAIL}`}>
                {env.VITE_SUPPORT_EMAIL}
              </a>
            </MLabel>
          </Stack>
        </Stack>
      </Stack>
      <RightWrapper
        direction="row"
        alignItems="center"
        justifyContent="center"
        flexBasis={{ xs: '0', md: '50%' }}
        flexShrink={0}
        display={{ xs: 'none', md: 'flex' }}
      >
        {right}
      </RightWrapper>
    </Stack>
  )
}
